<template>
  <PrimaryModal v-bind="$attrs" v-on="$listeners">
    <v-card-text>
      <p>
        已請款之訂單無法再次請款，請確認這些訂單是否要請款
      </p>
    </v-card-text>

    <v-card-text>
      <div class="d-flex justify-center">
        <v-btn min-width="100px" color="primary" @click="apply">確認</v-btn>
      </div>
    </v-card-text>
  </PrimaryModal>
</template>

<script lang="babel" type="text/babel">
import PrimaryModal from "components/modal/primaryModal.vue";
import modalMixins from "components/modal/modal"
export default {
  mixins: [modalMixins],
  props: {

  },
  components: {
    PrimaryModal,
  },

}
</script>